import {Component, Input} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import type {ActionButtonSeverity, ActionButtonType} from './action-buttons.types';
import {Ripple} from 'primeng/ripple';


@Component({
  selector: 'app-action-button',
  host: {
    '[style.pointer-events]': '"none"'
  },
  template: `
    <button pButton
            pRipple
            [class.p-0]="!padding"
            [disabled]="disabled || loading"
            [class.p-button-text]="textButton"
            [class.p-button-sm]="size === 'small'"
            [class.p-button-lg]="size === 'large'"
            [loading]="loading"
            [label]="label"
            [class]="buttonClass"
            [icon]="buttonIcon"
            [type]="buttonType"
            [iconPos]="iconPosition"
    ></button>
  `,
  styles: [`:host ::ng-deep button * {
    pointer-events: none;
  }`, `:host ::ng-deep button {
    pointer-events: all;
  }`],
  imports: [
    ButtonDirective,
    Ripple
  ],
  standalone: true
})
export class ActionButtonComponent {
    @Input() label: string = '';

    @Input() loading = false;

    @Input() type?: ActionButtonType;

    @Input() disabled = false;

    @Input()
    padding = true;

    @Input()
    textButton = false;

    @Input()
    size: 'small' | 'medium' | 'large' = 'medium';

    @Input() buttonType: 'button' | 'submit' | 'reset' = 'button';

    @Input()
    iconPosition: 'left' | 'right' | 'top' | 'bottom' = 'left';

    @Input()
    hasIcon = true;

    @Input()
    icon = '';

    @Input()
    severity?: ActionButtonSeverity;

    _buttonClass: string = '';
    get buttonClass() {
        return this._buttonClass !== '' ? this._buttonClass : ('p-button-' + this.color);
    }

    @Input()
    set buttonClass(value: string) {
        this._buttonClass = value;
    }

    get buttonIcon(): string {
        if (!this.hasIcon) {
            return '';
        }

        if (this.icon) {
            return this.icon;
        }

        switch (this.type) {
            case 'add':
                return 'pi pi-plus';
            case 'delete':
                return 'pi pi-trash';
            case 'info':
                 return 'pi pi-info-circle';
            case 'save':
                return 'pi pi-save';
            case 'run':
                return 'fa fa-gears';
            case 'reload':
                return 'pi pi-refresh';
            case 'copy':
                return 'fa fa-paste';
            case 'edit':
                return 'pi pi-pencil';
            case 'cancel':
                return 'pi pi-times';
            case 'clone':
                return 'fa fa-clone';
            case 'link':
                return 'pi pi-link';
            case 'unlink':
                return 'fa fa-unlink';
            case 'confirm':
                return 'pi pi-check';
            case 'calendar':
                return 'fa fa-calendar';
            case 'list':
                return 'fa fa-list';
            case 'payment':
                return 'fa fa-euro-sign';
            case 'download':
                return 'pi pi-download';
            default:
                return '';
        }
    }

    get color(): ActionButtonSeverity {

        if (this.severity) {
            return this.severity;
        }

        switch (this.type) {
            case 'add':
                return 'info';
            case 'copy':
                return 'secondary';
            case 'info':
                return 'info';
            case 'save':
                return 'success';
            case 'delete':
                return 'danger';
            case 'reload':
                return 'secondary';
            case 'run':
                return 'secondary';
            case 'cancel':
                return 'secondary';
            case 'clone':
                return 'secondary';
            case 'link':
                return 'primary';
            case 'unlink':
                return 'danger';
            case 'confirm':
                return 'success';
            case 'calendar':
                return 'secondary';
            case 'download':
                return 'info';
            default:
                return 'secondary';
        }
    }
}
